export default {
      id: "i-empty-flash-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-empty-flash",
      toString: function () {
        return this.url;
      }
    }